<template>
	<div id='ediotable'>
		<!-- <a-popover :visible="shShowBol" placement="left" :destroyTooltipOnHide="true" trigger="click"
			@visibleChange="shEvent()" :overlayStyle="{width:'calc(17rem + 32px)'}"
			:getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
			<template slot="content">
				<div class="tableBzView">
					<div class="tableBzViewTitle">狀 態</div>
					<div style="padding:0.8rem;width:100%;">
						<div class="tableBzViewList">
							<a-collapse style="background-color:#fcfcfc;" expandIconPosition="right" :accordion="true"
								:bordered="false">
								<div style="max-height: 300px;overflow: auto;">
									<div v-for="(item,index) in tableData" :key="index">
										<div class="p1" style="margin: .5rem 0;">
											<span style="color:#4d838a;font-size:0.85rem;">{{item.admin}}</span>
											<div v-if='item.handle == 0'>{{item.status}}</div>
											<div v-else-if='item.handle == 1' style="color: #3bc7a1;">{{item.status}}</div>
											<div v-else-if='item.handle == 2' style='color: #ed4853;'>{{item.status}}
											</div>
										</div>
										{{ item.remark }}
										<p>{{ item.createdate }}</p>
										<a-divider v-if='index + 1 < tableData.length' style='margin: .5rem 0;' />
									</div>
								</div>
								<div v-if='aduit'>
									<div class="tableBzViewTextarea" style="position:relative;">
										<a-textarea :maxLength=200 :autoSize="{minRows: 4, maxRows: 10}"
											style="padding-bottom:2rem;" v-model="textareaValue"
											placeholder="請輸入備註信息" />
									</div>
									<div class="tableBzViewBtnView">
										<a-popconfirm title="確認審批通過？" @visibleChange="visibleShow(record,'1')"
											v-model="popconfirm1Bol" ok-text="確定" cancel-text="取消"
											@confirm="shTgEvent(record,1)"
											:getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
											<a-icon slot="icon" type="question-circle-o" style="display: none;" />
											<a-button @click="ifClickBtn = true" class="tableBzViewBtn"
												style="background-color:#3bc7a1;">
												{{record.shKhadmin1Bol ? '已處理' :'審核通過'}}
											</a-button>
										</a-popconfirm>
										<a-popconfirm v-if="!record.shKhadmin1Bol" title="拒絕審批通過？"
											@visibleChange="visibleShow(record,'2')" v-model="popconfirm2Bol"
											ok-text="確定" cancel-text="取消" @confirm="shTgEvent(record,2)"
											:getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
											<a-icon slot="icon" type="question-circle-o" style="display: none;" />
											<a-button @click="ifClickBtn = true" class="tableBzViewBtn"
												style="background-color:#ed4849;">審核拒絕</a-button>
										</a-popconfirm>
									</div>
								</div>
							</a-collapse>
						</div>
					</div>
				</div>
			</template> -->
			<img :src="record.remarkflag || shShowBol ? icon_bianji1 : icon_bianji" class="imageC" @click='shEvent'>
			<shenhe v-if='shShowBol' :island='shShowBol' @child='shEvent' :record='record'></shenhe>
		<!-- </a-popover> -->
	</div>
</template>

<script>
	import App from '@/assets/app.js';
	import icon_bianji from '@/image/icon_mess_1.png';
	import icon_bianji1 from '@/image/icon_mess.png';
	import shenhe from './shenhe.vue'
	export default {
		components:{
			shenhe,
		},
		props: ['record'],
		data() {
			return {
				icon_bianji,
				icon_bianji1,
				shShowBol: false,
				tableData: [],
				popconfirm2Bol: false,
				popconfirm1Bol: false,
				aduit: false,
				textareaValue: ''
			}
		},
		mounted() {
			
		},
		methods: {
			visibleShow(record, type) {
				    let _this = this;
				    if(record.isreading < 1){
				        App.oTool.warningT('請先查看銀證轉帳收據');
				        _this.popconfirm1Bol = false;
						_this.popconfirm2Bol = false;
				        return
				    }
			},
			shTgEvent(record, type) { //1通過  //2拒絕
				if (!this.textareaValue) {
					if (type == 1) {
						this.textareaValue = '審核通過'
					} else if (type == 2) {
						App.oTool.warningT('請填寫備註信息');
						return
					}
				}

				this.$ajax({
					method: 'post',
					url: this.$api.newUserAduit,
					data: {
						"aduitid": this.record.aduitid,
						token: this.$store.state.token,
						"handle": type,
						remark: this.textareaValue
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						App.oTool.successT();
						this.textareaValue = ''
						this.$emit('child', true);
						this.shShowBol = false;
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			getdata() {
				this.$ajax({
					method: 'post',
					url: this.$api.getUserList,
					data: {
						"aduitid": this.record.aduitid,
						token: this.$store.state.token
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.tableData = res.data.userAduitLogList;
						this.aduit = res.data.aduit;
						// this.$emit('child', true);
						this.shShowBol = !this.shShowBol;
					}
				})
			},
			//第二操作
			shEvent() {
				if(this.record.aduitid){
					this.shShowBol = !this.shShowBol
					if(!this.shShowBol){
						this.$emit('child', true);
					}
				}else{
					this.$message.warning('暫無記錄')
				}
				// if (this.shShowBol) {
					// this.shShowBol = !this.shShowBol
				// } else {
				// 	this.textareaValue = ''
				// 	this.getdata()
				// }
			},
		}
	}
</script>

<style lang='scss' scoped>
	#ediotable {
		.p1 {
			div {
				float: right;
			}
		}

		.tableBzViewBtn {
			margin: 0 3rem !important;
		}
	}
</style>
